import React, { useState, useEffect, useContext } from "react";
import {
  getAllTvtsForClients,
} from "../services/NftServices";
import { Link } from "react-router-dom";
import { FaCircleChevronLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import Loader from "../components/loader/loader";
import { ethers } from "ethers";
import NoData from "../components/NoDataComp/NoData";
import TvtAbi from "../Abis/TvtAbi.json";
import SelltvtCard from "../components/Tvt/SellTvtCard";
import { ConversionContext } from "../Context/context";
import { ethers5Adapter } from "thirdweb/adapters/ethers5";
import { polygon } from "thirdweb/chains";
import { useActiveAccount } from "thirdweb/react";
import { client } from "../runtime.config";
const ViewAllSellTvts = () => {
  const contextData = useContext(ConversionContext);
  const UserId = contextData?.userId;
  const activeAccount=useActiveAccount();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userMarketplaceTvts, setUserMarketplaceTvts] = useState([]);

  const fetchUserMarketplaceTvts = async () => {
    try {
      setLoading(true);
      const response = await getAllTvtsForClients();

      if (response.status === 200) {
        const allTvtData = response?.data?.items;
        let result = [];
        for (let index = 0; index < allTvtData.length; index++) {
          const element = allTvtData[index];
          let res = await getMarketplaceTvts(element?.contractAddress);
          if (res) {
            if (res.length > 0) {
              for (let index = 0; index < res.length; index++) {
                const tvtDetail = res[index];
                // eslint-disable-next-line eqeqeq
                if (tvtDetail?.tvtCount != 0 && element?.isNewTvt) {
                  const intBalance = element?.isPurchasable ? ethers.utils.formatEther(tvtDetail?.tvtPrice.toString()) : tvtDetail?.tvtPrice.toString();
                  result.push({
                    ...element,
                    balance: intBalance,
                    quantity: tvtDetail?.tvtCount.toString(),
                    address: tvtDetail?.userAddress,
                  });
                }
              }
            }
          }
        }
        setUserMarketplaceTvts(result);
        setLoading(false);
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching nft data:", error);
    }
  };
  const getMarketplaceTvts = async (data) => {
    const signer = await ethers5Adapter.signer.toEthers({ client, chain:polygon, account:activeAccount });
    const nftContract = new ethers.Contract(data, TvtAbi, signer);
    let respones = await nftContract?.getAllUserData();
    return respones;
  };

  useEffect(() => {
    fetchUserMarketplaceTvts();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="p-4">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link
          className="back-btn fw-500 text-black py-4"
          onClick={() => navigate(-1)}
        >
          <i className="pe-2 align-middle">
            <FaCircleChevronLeft />
          </i>
          Back
        </Link>
        {/* <div>
          <input
            type="search"
            placeholder="Search NFT"
            style={{
              borderRadius: "12px",
              border: "none",
              padding: "5px 20px",
              background: "#d3d3d3a1",
            }}
            value={filter}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div> */}
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className="dashboard-centerd">
          {userMarketplaceTvts?.length > 0 ? (
            <div className="row g-0">
              <div className="row mb-4">
                {userMarketplaceTvts?.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className="col-xxl-3 col-xl-3 col-md-6 col-12 mb-4"
                    >
                      <SelltvtCard
                        data={item}
                        fetchData={fetchUserMarketplaceTvts}
                        setLoading={setLoading}
                        UserId={UserId}
                      />
                    </div>
                  );
                })}
              </div>
              {/* {totalData > 12 && (
                <div
                  style={{
                    marginTop: "10px",
                    marginBottom: "10px",
                    // minWidth: "200%",
                  }}
                >
                  <Pagination
                    color="primary"
                    count={Math.ceil(totalData / 12)}
                    page={page}
                    onChange={(e, v) => setPage(v)}
                    // activePage={page}
                  />
                </div>
              )} */}
            </div>
          ) : (
            <NoData />
          )}
        </div>
      )}
    </div>
  );
};

export default ViewAllSellTvts;
